module.exports = __webpack_public_path__ + "static/media/SUBDRIVECONNECT.b94a3ee7.pdf";